module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentPlatform !== 'ios') ? _c('div', {
    attrs: {
      "id": "download-other-version"
    }
  }, [(_vm.stableVersionInfo) ? _c('a', {
    attrs: {
      "href": _vm.stableVersionInfo.download_link || '#'
    }
  }, [_vm._v(_vm._s(_vm.$t('stableVersion')) + _vm._s(_vm.stableVersionInfo.version_name))]) : _vm._e(), _vm._v(" "), (_vm.betaVersionInfo) ? _c('a', {
    attrs: {
      "href": _vm.betaVersionInfo.download_link || '#'
    }
  }, [_vm._v(_vm._s(_vm.$t('betaVersion')) + _vm._s(_vm.betaVersionInfo.version_name))]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d35ba88!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/download/downloadOtherVersion/DownloadOtherVersion.vue
// module id = 1321
// module chunks = 1